import React from "react";
import { Link } from "react-router-dom";
import { COMPANY_NAME } from "../../constants/company";
import logo from "../../assets/img/logo.png";
import "../../assets/css/innerLanding.scss";

/** Privacy / Terms: logo bar only — no site nav, footer, or landing modals */
export default function LegalMinimalLayout({ children }) {
  return (
    <div className="refined-legal-minimal">
      <header className="rs-legal-minimal-top">
        <div className="rs-legal-minimal-inner">
          <Link to="/" className="rs-legal-minimal-logo">
            <img src={logo} alt={COMPANY_NAME} />
          </Link>
        </div>
      </header>
      {children}
    </div>
  );
}
